<template>
  <el-button
    :size="size" :type="type"
    :loading="loading"  :disabled="disabled"
    v-if="hasAuthority"
    v-bind="$attrs"
    :hidden="hasAuthority"
    @click="handleClick"
  >
    <slot/>
  </el-button>
</template>
<script>

export default {
  name: 'permission-button',
  props: {
    permissionKey: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: 'Button'
    },
    size: {
      type: String,
      default: 'mini'
    },
    type: {
      type: String,
      default: null
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      hasAuthority: true
    }
  },
  created () {
    if (this.permissionKey) {
      this.hasAuthority = this.$store.state.MerchantMe.permissions.hasOwnProperty(this.permissionKey)
    } else {
      this.hasAuthority = false
    }
  },
  methods: {
    handleClick () {
      this.$emit('click', {})
    }
  },
  mounted () {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Buttons/permission-button.vue